import { type ILogger } from '@cian/logger/shared';
import { GenericError, HttpBadStatusCodeError, HttpCancelError } from '@cian/peperrors/shared';

import { type ILogRequestService } from '../ILogRequestService';

export class LogRequestService implements ILogRequestService {
  private readonly logger: ILogger;

  public constructor(logger: ILogger) {
    this.logger = logger;
  }

  public logFetchError<Error = unknown>(error: Error): void {
    let logLevel: Exclude<keyof ILogger, 'debugEnabled'>;

    if (error instanceof GenericError) {
      //@ts-expect-error
      const level = error?.details?.level;

      switch (level) {
        case 'debug':
        case 'warning':
        case 'error':
          logLevel = level;
          break;
      }
    }

    logLevel ??= 'error';

    this.getErrorLogger(logLevel)(error);
  }

  private getErrorLogger(logLevel: Exclude<keyof ILogger, 'debugEnabled'>) {
    return <Err = unknown>(error: Err): void => {
      if (error instanceof HttpCancelError) {
        this.logger.debug(error.message, {
          details: error.printDetails(),
          domain: error.domain,
          message: error?.details?.message,
          name: error.name,
          stack: error.stack,
          type: error.type,
        });
      } else if (error instanceof HttpBadStatusCodeError) {
        this.logger[logLevel](error.message, {
          details: error.printDetails(),
          domain: error.domain,
          message: error?.details?.message,
          name: error.name,
          stack: error.stack,
          statusCode: error.statusCode,
          type: error.type,
        });
      } else if (error instanceof GenericError) {
        this.logger[logLevel](error.message, {
          details: error.printDetails(),
          domain: error.domain,
          message: error?.details?.message,
          name: error.name,
          stack: error.stack,
          type: error.type,
        });
      } else {
        this.logger.error(error as Error, {
          description:
            'Неизвестная ошибка, нужно обязательно описать её в логгере приложения. Либо в сервисе запроса некорректно выбрасывается ошибка, нужно фиксить!',
        });
      }
    };
  }
}
